// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpFunctionIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpFunctionIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpFunctionIconOutlined = function DrrpFunctionIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpFunctionIconOutlinedSvg
  }));
};

DrrpFunctionIconOutlined.displayName = 'DrrpFunctionIconOutlined';
export default React.forwardRef(DrrpFunctionIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpFunctionIconOutlined.js
// module id = 2570
// module chunks = 0